module.exports = __webpack_public_path__ + "media/images/shop/logo-meet-white-84fb6f825698cf8284020a8989131491.svg";